import { getConfig } from './config'

type Login = {
  email?: string;
  password?: string;
  captcha?: string;
  type?: 'facebook' | 'google';
  accessToken?: string;
}

export type Subscription = {
  isSubscribed: boolean;
  cancellationEffectiveDate: Date;
}

export type User = {
  _id: string;
  profile: 'admin' | 'user';
  status: 'active' | 'inactive';
  avatar?: string | null;
  name: string;
  email: string;
  updatedAt: Date;
  createdAt: Date;
  gender: 'male' | 'female';
  birthDate: Date;
  occupation: string;
  phone: string;
  lastAccessAt: Date;
  subscription: Subscription;
  isVerified?: boolean;
}

export type LoginResponse = {
  user: User;
  accessToken: string;
  refreshToken: string;
}

export type RefreshTokenResponse = {
  user: User;
  accessToken: string;
}

export const login = async ({ email, password, ...restParams }: Login): Promise<LoginResponse> => {
  const config = getConfig()
  const response = await config.axios.post<LoginResponse>(`${config.API_URL}/auth/login`, {
    email,
    password,
    ...restParams
  })

  return response.data
}

export const user = async (): Promise<User> => {
  const config = getConfig()
  const response = await config.axios.get<User>(`${config.API_URL}/auth/user`)

  return response.data
}

export const refreshToken = async (): Promise<RefreshTokenResponse> => {
  const config = getConfig()
  const response = await config.axios.post<RefreshTokenResponse>(`${config.API_URL}/auth/token`)

  return response.data
}

export const logout = async (): Promise<void> => {
  const config = getConfig()
  await config.axios.post<RefreshTokenResponse>(`${config.API_URL}/auth/logout`)
}
